import React from "react";
import "./ListeningBars.css";

// The "listening for requests" sign beside PENDING REQUESTS (founder, build
// 44: an equalizer instead of the circling ball). Shown only while the
// queue is empty; Offline it stops, flat and grey — not listening.
// Keeps the .pending-spinner name the page and its tests know.
const ListeningBars: React.FC<{ live: boolean }> = ({ live }) => (
  <span className={`pending-spinner listening-bars${live ? "" : " pending-spinner--paused"}`} aria-hidden="true">
    <i />
    <i />
    <i />
    <i />
  </span>
);

export default ListeningBars;
